module.exports = __webpack_public_path__ + "img/ckja4.9d974637.jpeg";